<template>
  <div>
    <RevTag v-if="badge" :label="badge" variant="info" />
    <h1 class="heading-1 pr-5" :class="textColorStyle">
      {{ title }}
    </h1>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { BannerTextColor } from '@backmarket/http-api/src/api-specs-content/models/banner'
import { RevTag } from '@ds/components/Tag'

const props = withDefaults(
  defineProps<{
    title: string
    badge?: string
    textColor?: BannerTextColor
  }>(),
  {
    textColor: BannerTextColor.Black,
    badge: '',
  },
)

const textColorStyle = computed(() => {
  return props.textColor === BannerTextColor.White
    ? 'text-static-light-hi'
    : 'text-static-default-mid'
})
</script>
